import { useCreatorCommunities } from '../api/useCreatorCommunities';
import { useMarkCommunityVisited } from '../lib/useMarkCommunityVisited';
import { CommunitiesContent } from './CommunitiesContent';
import { CommunitiesError } from './CommunitiesError';
import { CommunitiesPageSkeleton } from './CommunitiesPageSkeleton';
import { EmptyCommunities } from './EmptyCommunities';
import { pageBackground } from '@client/new/pages/page-background.css';

type Props = {
  influencerId?: string;
};

export const CommunitiesV2Page = ({ influencerId }: Props) => {
  useMarkCommunityVisited();
  const communities = useCreatorCommunities(influencerId);

  const renderContent = () => {
    switch (communities.type) {
      case 'not-fetched':
      case 'fetching':
        return <CommunitiesPageSkeleton />;
      case 'fetch-error':
        return <CommunitiesError />;
      case 'fetched':
        return communities.value.length === 0 ? (
          <EmptyCommunities />
        ) : (
          <CommunitiesContent
            communities={communities.value}
            influencerId={influencerId}
          />
        );
    }
  };

  return <div className={pageBackground}>{renderContent()}</div>;
};
